import { __rest, __assign } from '../../../_virtual/_tslib.js';
import React, { useEffect } from 'react';
import classnames from 'classnames';
import ScrollLock from 'react-scrolllock';
import ReactModal from 'react-modal';
import styles from './styles.css.js';

var Modal = function Modal(_a) {
  var children = _a.children,
      isOpen = _a.isOpen,
      className = _a.className,
      overlayClassName = _a.overlayClassName,
      _b = _a.isScrollLockActive,
      isScrollLockActive = _b === void 0 ? true : _b,
      props = __rest(_a, ["children", "isOpen", "className", "overlayClassName", "isScrollLockActive"]);

  useEffect(function () {
    ReactModal.setAppElement('body');
  }, []);
  return React.createElement(ReactModal, __assign({}, props, {
    isOpen: isOpen,
    className: classnames(styles.modal, className),
    overlayClassName: classnames(styles.overlay, overlayClassName)
  }), React.createElement(ScrollLock, {
    isActive: isScrollLockActive
  }, React.createElement("div", {
    className: styles.modalContent
  }, children)));
};

export default Modal;
//# sourceMappingURL=index.js.map
